import ReuseModal from "../../../components/fragment/modal/ReuseModal";

interface DeleteNotificationCampaignModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  campaign: { title?: string } | null;
  loading?: boolean;
}

const DeleteNotificationCampaignModal = ({
  visible,
  onClose,
  onConfirm,
  campaign,
  loading,
}: DeleteNotificationCampaignModalProps) => {
  return (
    <ReuseModal
      title="Delete Notification ?"
      btnLabel="Delete"
      visible={visible}
      onClose={onClose}
      loading={loading}
      onBtnClick={onConfirm}
      classname="modal-delete"
    >
      <div className="py-4">
        <p className="text-xl md:text-lg text-[#1E1E1E]">
          Are you sure you want to delete{" "}
          <span className="font-semibold">"{campaign?.title}"</span>?
        </p>

        <p className="mt-2 text-lg md:text-md text-[#758089]">
          This action cannot be undone.
        </p>
      </div>
    </ReuseModal>
  );
};

export default DeleteNotificationCampaignModal;
